import { X } from "lucide-react";

export const VideoModal = ({ post, onClose }) => {
  if (!post) return null;
  return (
    <div data-testid="video-modal" className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <div className="overline-label text-signal">// Intelligence Briefing — {post.source}</div>
          <button data-testid="video-modal-close" onClick={onClose} className="text-white hover:text-signal p-2">
            <X size={24} />
          </button>
        </div>
        <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${post.youtube_id}?autoplay=1`}
            title={post.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <h3 className="font-display text-xl sm:text-2xl font-bold text-white mt-4">{post.title}</h3>
        <p className="font-body text-white/70 mt-2">{post.summary}</p>
        <a
          data-testid="video-source-link"
          href={post.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-3 font-mono2 text-xs uppercase tracking-[0.2em] text-cyan hover:text-signal"
        >
          View Original Source ↗
        </a>
      </div>
    </div>
  );
};
